namespace $ { export class $mol_linker extends $mol_viewer {

	/// heightMinimal 36
	heightMinimal() {
		return 36
	}

	/// tagName \a
	tagName() {
		return "a"
	}

	/// uri \
	uri() {
		return ""
	}

	/// current false
	current() {
		return false
	}

	/// attr * 
	/// 	href < uri 
	/// 	mol_linker_current < current
	attr() {
		return $mol_merge_dict( super.attr() , {
			"href" : ()=> <any> this.uri() ,
			"mol_linker_current" : ()=> <any> this.current() ,
		} )
	}

	/// arg *
	arg() {
		return ({
		})
	}

} }

